import { useState } from "react";

/**
 * Hook to control the visible state of
 */
const useModal = (initial = false) => {
  const [isOpen, setValue] = useState(initial);

  const open = () => {
    document.body.style.overflow = "hidden";
    setValue(true);
  };

  const close = () => {
    document.body.style.overflow = "unset";
    setValue(false);
  };

  const toggle = () => (isOpen ? close() : open());

  return { isOpen, open, close, toggle } as const;
};

export default useModal;
